module.exports = __webpack_public_path__ + "static/media/libro8.fd1c675a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro8.png
// module id = 356
// module chunks = 0